import { IExampleDrivers, IExampleLocation } from './interfaces';

const drivers: IExampleDrivers = {
  name: `Ciudad de México`,
  location: {
    lat: 19.432608,
    lng: -99.133209,
  },
  drivers: {
    label: [`Carlos`, `Jorge`, `Ernesto`],
    start_address: [
      `Adolfo Prieto 1925, Acacias, Benito Juárez, 03240 Ciudad de México, CDMX, México`,
      `Adolfo Prieto 1925, Acacias, Benito Juárez, 03240 Ciudad de México, CDMX, México`,
      `Adolfo Prieto 1925, Acacias, Benito Juárez, 03240 Ciudad de México, CDMX, México`,
    ],
    end_address: [
      `Adolfo Prieto 1925, Acacias, Benito Juárez, 03240 Ciudad de México, CDMX, México`,
      `Adolfo Prieto 1925, Acacias, Benito Juárez, 03240 Ciudad de México, CDMX, México`,
      `Av. Baja California, Colonia Condesa, Cuauhtémoc, 06100 Ciudad de México, CDMX, México`,
    ],
  },
};

const stops: IExampleLocation = {
  name: `Ciudad de México`,
  location: {
    lat: 19.432608,
    lng: -99.133209,
  },
  stops: {
    label: [
      `El Paisa`,
      `Tacos El Papi`,
      `El Super Taco`,
      `Tacos Memo`,
      `Tacos Norteños Blanquita`,
      `El Vilsito`,
      `Asadero Los del Norte`,
      `Yeshua Tacos`,
      `Los Provolones`,
      `Don Alejandro`,
    ],
    address: [
      `Av. Tlahuac 481, Culhuacan, Iztapalapa, 09800 Ciudad de México, CDMX`,
      `Ote 91 3229, Mártires de Río Blanco, Gustavo A. Madero, 07880 Ciudad de México, CDMX`,
      `Calz. de las Bombas 774, Coapa, Cafetales I, Coyoacán, 04930 Ciudad de México, CDMX`,
      `Calle Gabino Barreda 18, San Rafael, Cuauhtémoc, 06470 Ciudad de México, CDMX`,
      `Atanasio G. Sarabia, Héroes de Churubusco, Iztapalapa, 09090 Ciudad de México, CDMX`,
      `Av. Universidad, Narvarte Poniente, Benito Juárez, 03020 Ciudad de México, CDMX`,
      `Florales 34, Coapa, Sauzales Cebadales, Tlalpan, 14334 Ciudad de México, CDMX`,
      `Calle del Carmen 43, Centro Histórico de la Cdad. de México, Centro, Cuauhtémoc, 06000 Ciudad de México, CDMX`,
      `Rosales, Tabacalera, Cuauhtémoc, 06030 Ciudad de México, CDMX`,
      `Calle C, Área Federal Central de Abastos, Iztapalapa, Ciudad de México, CDMX`,
    ],
    address_details: [`Edificio C`, `Piso 1`, `Oficina 33`, `Bdg 3`, ``, ``, ``, ``, ``, `Interior 203`],
    delivery_label: [
      `Margarita Hernández`,
      `Juan García`,
      `Sofía Cruz`,
      `Camila Flores`,
      `Pedro Gómez`,
      `Manuel Martínez`,
      `Roberto Rodríguez`,
      `Michelle Sánchez`,
      `Gabriel González`,
      `Teresa López`,
    ],
    delivery_address: [
      `Calle Comonfort 83, Peralvillo, Morelos, Cuauhtémoc, 06200 Ciudad de México, CDMX, México`,
      `Av. Insurgentes Nte. 260, Sta María la Ribera, Cuauhtémoc, 06400 Ciudad de México, CDMX, México`,
      `Carpintería 51-65, Morelos, Venustiano Carranza, 15270 Ciudad de México, CDMX, México`,
      `Gral. Miguel Miramón 103, Martín Carrera, Gustavo A. Madero, 07070 Ciudad de México, CDMX, México`,
      `El Universal 1084, Prensa Nacional, 54170 Tlalnepantla de Baz, Méx., México`,
      `Calle Colima 119, Hab Jacarandas, 54050 Tlalnepantla de Baz, Méx., México`,
      `Segunda Calle Cajamarca 83, Las Americas, 53040 Naucalpan de Juárez, Méx., México`,
      `Avenida Prado Norte 360, Lomas - Virreyes, Lomas de Chapultepec, Miguel Hidalgo, 11000 Ciudad de México, CDMX, México`,
      `Lago Zirahuen 66, Anáhuac I Secc., Anáhuac I Secc, Miguel Hidalgo, 11320 Ciudad de México, CDMX, México`,
      `Calle Golfo de Sidra 45, Tacuba, Miguel Hidalgo, 11410 Ciudad de México, CDMX, México`,
    ],
    delivery_address_details: [
      `Esquina Manuel Montt con Providencia`,
      `Oficina B`,
      ``,
      ``,
      `Piso 7, oficina 392`,
      ``,
      `Piso 3`,
      `Calle`,
      `Calle`,
      ``,
    ],
  },
};

export { drivers, stops };
